import React from "react";
import styled from "styled-components";
import { Col, Row } from "react-bootstrap";

const Terms = () => {
  return (
    <Container>
      <Row>
        <Col xs={12}>
          <h1
            style={{
              fontSize: "26px",
              fontWeight: "bold",
              textAlign: "center",
              width: "100%",
              paddingTop: "10%",
              color: "#D01E2D",
            }}
          >
            BALWIN WEBSITE <br />
            TERMS AND CONDITIONS
            <br />
          </h1>
          <br />
          <p class="p2">
            <span class="s1">
              The use of the Balwin Website is subject to the Terms and
              Conditions below. You acknowledge that you have read, understood
              and accepted, without reserve, these Terms and Conditions as well
              as the Data Protection Policy, as modified from time to time by
              us, by accessing, browsing and using our Website you acknowledge
              that you have read, understood and accepted, without reserve,
              these Terms and Conditions as well as the Data Protection Policy,
              as modified from time to time by us.
              <br />
              We reserve the right to modify, change or make corrections to our
              Terms and Conditions and/or Data Protection Policy at any time and
              without any notice. In such event, we will make a new dated
              version available through this link. We ask that you consult these
              Terms and Conditions from time to time in order to familiarize
              yourself with any changes.
            </span>
          </p>
          <p>1. DEFINITIONS</p>

          <p>
            1.1. “Content” means, but is not limited to text, graphics, icons,
            links and other similar material on the Website;
          </p>

          <br />

          <p>
            1.2. “Intellectual Property” means the copyright (including but not
            limited to literary (including database and computer programs)
            artistic, musical works, photographs, and sound recordings),
            patents, trademarks (including all related domain names and meta
            tags), confidential information, trade secrets and design rights
            (including all applications);
          </p>

          <br />

          <p>
            1.3. “Software” means the software utilised to give you access to
            and use of the Website;
          </p>

          <br />

          <p>
            1.4. “Website” means (i) the Balwin website, and all its pages and
            content, owned by Balwin; (ii) the Balwin mobile application; and
            (iii) any Balwin social network pages (including but not limited to
            Facebook, Instagram, Twitter, YouTube or any other social media
            facility or software programme made available by us from time to
            time).
          </p>

          <br />

          <p>2. ABOUT US</p>

          <br />

          <p>2.1. Name: Balwin Properties Limited (“Balwin” or “We” or “Us”)</p>

          <br />

          <p>2.2. Registration Number: 2003/028851/06</p>

          <br />

          <p>2.3. Physical Address: Townsend Office Park</p>

          <p>1 Townsend Avenue</p>

          <p>Bedfordview</p>

          <p>2008</p>

          <br />

          <p>2.4. Postal Address: Private Bag X4, Gardenview, 2047</p>

          <br />

          <p>3. ALLOWED USE OF THE WEBSITE</p>

          <br />

          <p>
            3.1. Subject to paragraph 3.6 below, We license to you, subject to
            these Terms and Conditions, a non-exclusive, non-transferable,
            limited and revocable right to access the Website and display, use,
            download, and otherwise copy the current and future Content for
            personal, non- commercial and information purposes only and to
            upload content in accordance with paragraph.3.2. Any other use,
            including the reproduction, modification, distribution, transmission
            or broadcast of the content of the Website, in whole or in part and
            by any means, is strictly prohibited, except upon prior written
            consent of Balwin.
          </p>

          <br />

          <p>
            3.3. Balwin neither warrants nor represents that your use of any
            content displayed on its Website will not infringe rights of third
            parties.
          </p>

          <br />

          <p>
            3.4. We do not guarantee that our Website, or any content on it,
            will always be available to be uninterrupted. Access to our Website
            is permitted on a temporary basis and access may be suspended due to
            unforeseen circumstances.
          </p>

          <br />

          <p>3.5. License Conditions</p>

          <br />

          <p>
            3.5.1. Other than as agreed to above, you may not use, copy, adapt,
            redistribute or modify the Content or any part thereof or frame,
            "mirror", datamine (by way of but not limited to, robots, crawlers
            or other similar programs) or cache the Website or reverse engineer,
            copy, modify, re-distribute, decompile or create a derivative work
            of the Website or Software, or any part thereof without prior
            written authorisation from Us.
          </p>

          <br />

          <p>
            3.5.2. We do not offer products or services to minors. If you are
            under the age of 18, you may not respond to or otherwise accept or
            act upon any invitations to do business on the Website and you must
            keep intact all notices that refer to this License and to the
            Limitation of Liability hereunder.
          </p>

          <br />

          <p>
            3.5.3. You agree to supervise all usage by minors (younger than 18
            years) of this Website under your name or account.
          </p>

          <br />

          <p>
            3.5.4. You may not assign, transfer or sublicense the rights
            pursuant to these terms and conditions.
          </p>

          <br />

          <p>
            3.5.5. You may not use the Website’s communication facilities for
            purposes of unsolicited communications (“Spam”) or to send or
            publish any content that is in violation of any law or that are
            obscene, defamatory, racist or offensive in nature or may result in
            the infringement of any intellectual property.
          </p>

          <br />

          <p>
            3.5.6. You may only upload material in accordance with paragraph 3.7
            below.
          </p>

          <br />

          <p>
            3.5.7. You acknowledge that Your fair use and other rights are in no
            way affected by the above.
          </p>

          <br />

          <p>3.6. Hyperlinks from the Website</p>

          <br />

          <p>
            3.6.1. The Website may contain links to other websites operated by
            third parties. We do not: endorse the operators and/or owners of
            third-party websites; operate or control any of the information,
            graphics and material on those third-party websites; or guarantee
            that third-party websites will always be operational.
          </p>

          <br />

          <p>
            3.6.2. Links to third-party websites are included solely for your
            convenience and We assume no responsibility for your use of
            third-party websites.
          </p>

          <br />

          <p>3.6.3. We make no warranties or representations:</p>

          <p>
            3.6.3.1. on the quality, accuracy, reliability, legality,
            merchantability or fitness for purpose of third-party website
            content or products or services available through any third-party
            website; and/or
          </p>

          <br />

          <p>
            3.6.3.2. that third-party website content does not infringe the
            intellectual property rights of any person.3.6.4. We expressly
            disclaim acting in any respect on behalf of any third-party website
            operators and/or owners. Please note that third-party websites may
            be subject to their own terms of use and privacy policies different
            from those of this Website.
          </p>

          <br />

          <p>3.7. Uploading Material to the Website</p>

          <br />

          <p>
            3.7.1. Whenever you make use of a feature that allows you to upload
            material to the Website, or to make contact with other users of our
            Website, you must comply with the content standards set out in
            clause 3.8 below. You warrant that any upload or contribution from
            you complies with those standards, and you indemnify us for any
            breach of that warranty.
          </p>

          <br />

          <p>
            3.7.2. Material or contributions that you upload will either be
            uploaded to areas that are accessible to other Website users or
            areas that are only accessible to you and Us to enable Us or our
            appointed service providers to operate the Website.
          </p>

          <br />

          <p>
            3.7.3. Any material you upload to the Website is protected and
            treated according to our Privacy Policy. We ask that you read our
            Privacy Policy carefully before providing Us with any personally
            identifying data and/or information.
          </p>

          <br />

          <p>
            3.7.4. Any information or material communicated to Us that is not
            personal information will be considered non-confidential and
            non-proprietary, and We have the right to use, copy, distribute and
            disclose to third-parties any such material for any purpose.
          </p>

          <br />

          <p>
            3.7.5. You warrant that you own any material and/or content
            submitted by you and that it is not defamatory in nature and that
            any use, copy, distribution or disclosure of such material and/or
            content will not violate any third-party’s rights.
          </p>

          <br />

          <p>
            3.7.6. We reserve the right to edit or remove any material submitted
            to the Website, or stored on Our servers, or hosted or published
            upon our Website.
          </p>

          <br />

          <p>
            3.7.7. We have the right to disclose your identity to any
            third-party who is claiming that any material posted or uploaded by
            you to the Website constitutes defamation, a violation of their
            intellectual property rights, or of their right to privacy, subject
            to reasonable prior notification to you.
          </p>

          <br />

          <p>
            3.7.8. We will not be responsible, or liable to any third-party, for
            the content or accuracy of any materials posted by you or any other
            user of the Website. Posts reflect the views and opinion of the
            author, but not necessarily of the owners and operators of the
            interactive services available on the Website. If you feel that any
            submitted message on the Website is questionable, we encourage you
            to notify us immediately.
          </p>

          <br />

          <p>
            3.7.9. We have the right to remove any material or posting you make
            on the Website if, in our opinion, such material does not comply
            with the content standards set out in 3.8 below.
          </p>

          <br />

          <p>
            3.7.10. From time to time certain third-party content will be
            uploaded to the Website. We have no control over the content of said
            uploads and shall not be liable for any claims or damages that may
            result from such uploads. If you feel that any of the content
            uploaded is inaccurate or offensive, we encourage you to notify us
            immediately.
          </p>

          <br />

          <p>
            3.7.11. You shall abide to the particular social network’s code of
            conducts and guidelines, including but not limited to the Code of
            Conduct (Facebook), General Guidelines and Policies (Twitter) and
            Community Guidelines (Instagram) or any other similar rules and
            guidelines made available by the particular social media network.
            You acknowledge and agree that We may, but are not obligated to,
            monitor the content on the social media network page(s) and may
            delete or remove from the said page immediately without notice any
            content of whatever nature, for any or no reason, including without
            limitation, if suchcontent in our absolute discretion is in breach
            of any of the rules or guidelines made available or in breach of
            these terms and conditions.
          </p>

          <br />

          <p>
            3.7.12. Social media is not a medium for conflict resolution or
            lodging complaints.
          </p>

          <p>Complaints should be sent to support@thinkdigital.co.za .</p>

          <br />

          <p>3.8. Content Standards</p>

          <br />

          <p>
            These content standards apply to any and all material and/or content
            that you contribute to the Website (“Contributions”), and to any
            interactive services associated with the contributions.
          </p>

          <br />

          <p>3.8.1. Contributions may not:</p>

          <br />

          <p>
            3.8.1.1. contain any material and/or content that is defamatory in
            nature, or any material which is obscene, offensive, hateful or
            inflammatory, or that promotes sexually explicit material, or
            violence, or discrimination based on race, sex, religion,
            nationality, disability, sexual orientation, or age;
          </p>

          <br />

          <p>
            3.8.1.2. infringe any intellectual property rights of any other
            person or be likely to deceive any person or be made in breach of
            any legal duty owed to a third party, such as a contractual duty or
            a duty of confidence;
          </p>

          <br />

          <p>
            3.8.1.3. promote any illegal activity or be threatening, abuse or
            invade another’s privacy, or cause annoyance, inconvenience or
            needless anxiety or be likely to harass, upset, embarrass, alarm or
            annoy any other person
          </p>

          <br />

          <p>
            3.8.1.4. contain any damaging code or viruses, or any other software
            or programs that may interfere with or damage the operation of the
            Website or any other computer.
          </p>

          <br />

          <p>3.8.2. You may:</p>

          <br />

          <p>
            3.8.2.1. not impersonate any person or entity, or falsely state or
            otherwise misrepresent yourself in any way;
          </p>

          <br />

          <p>
            3.8.2.2. only upload or submit material to the social network page
            which either you own or which you have the permission from the owner
            of that material to upload or submit.
          </p>

          <br />

          <p>3.9. Products and services sold through the Website</p>

          <br />

          <p>
            3.9.1. Products and/or services (if any) sold through the Website
            will be billed in Rands including VAT. You will have the
            opportunity, at the ‘check-out’ stage of the order process, to
            finally review and accept the
          </p>

          <br />

          <p>
            3.9.2. Delivery costs (if any) will be quoted separately to the cost
            of any item(s) at ‘check-out’.
          </p>

          <br />

          <p>
            3.9.3. Payment for Products and/or Services is accepted via credit
            card (Visa or Mastercard) and direct transfer. Online credit card
            transactions will be processed on the Website via PayGate. Any and
            all payments processed through the website will, in additions to
            these Terms and Conditions, be subject to the terms and conditions
            contained at the following address:{" "}
            <a href="http://www.paygate.co.za/terms-and-conditions/">
              www.paygate.co.za/terms-and-conditions/.
            </a>
          </p>

          <br />

          <p>3.9.3.1. .</p>

          <br />

          <p>
            4. INTELLECTUAL PROPERTY RIGHTS4.1. The Intellectual Property
            available on the Website or to be made available by Us or any of our
            selected service providers or agents is the property of, or licensed
            to, Us and may not be utilized outside the licensed terms as set out
            under these terms and conditions.
          </p>

          <br />

          <p>
            4.2. All uploads by you to the Website will be dealt with as your
            property. You hereby indemnify us against any claim whatsoever for
            the infringement of Intellectual Property of a third party or breach
            of Confidential Agreement between you and any third party as a
            result of an upload or submission from you to the Website.
          </p>

          <br />

          <p>
            4.3. The names, images and logos identifying Us or third parties and
            their services and products are subject to copyright, design right
            and trademark protection. Unless specifically agreed to under these
            Terms and Conditions, nothing contained herein shall be construed as
            conferring any licence or right to use any trade mark, design right
            or copyright of Us or any other third party.
          </p>

          <br />

          <p>
            4.4. E-mail addresses, names, telephone numbers and fax numbers
            published on the Website may not be incorporated into any database
            used for electronic marketing or similar purposes. The presentation
            by you of such details is no “opt-in” / permission from Us to
            utilise same for the above purposes.
          </p>

          <br />

          <p>5. SECURITY</p>

          <br />

          <p>
            5.1. Although We are not obliged to provide security on the Website
            we feel it is important that your information or any communication
            between you and Us is dealt with in the most secure manner
            reasonably possible, however because of the nature of the internet,
            We cannot warrant that your interaction with Us via the Website is
            completely secure.
          </p>

          <br />

          <p>
            5.2. To provide adequate security to all users of the Website and to
            monitor activities prohibited under law you hereby agree to Our or
            Our appointed service provider(s) right to intercept, monitor,
            block, read, delete or access all data sent to the Website or any
            other communication facility made available by Us.
          </p>

          <br />

          <p>5.3. Virus Checks</p>

          <br />

          <p>
            5.3.1. It is our policy to virus check documents and files before
            they are posted on the Website.
          </p>

          <p>
            However, we cannot guarantee that documents or files downloaded from
            the Website will be free from viruses and We do not accept any
            responsibility for any damage or loss
          </p>

          <p>
            caused by any virus. Accordingly, for your own protection, you must
            use virus checking
          </p>

          <p>
            software when using the Website. Further, you may not post or
            provide to us via the Website, any document or file that may contain
            a virus. You must virus check any document or file which you intend
            to post or provide to us via the Website.
          </p>

          <br />

          <p>
            5.3.2. You hereby indemnify Us and our service providers and
            affiliates against any possible damages, expenses or losses as a
            result of the delivery of computer programs or any other code that
            may damage the Website or our infrastructure or our service
            provider’s infrastructure.
          </p>

          <br />

          <p>5.4. Username and Passwords</p>

          <br />

          <p>
            5.4.1. When you own property, or are residing within the a Balwin
            development you will be able to register and obtain an account, that
            will enable you to access specific services made available to you
            for your convenience.
          </p>

          <br />

          <p>
            5.4.2. The information we capture during the registration process
            will be dealt with as per our
          </p>

          <p>
            Data Protection Policy.5.4.3. On registration you will receive a
            username and password to login to the Website and associated
            database(s). You agree that: (i) you are responsible for ensuring
            that no unauthorised access to the Website is obtained using your
            username and password; (ii) you will keep the username and password
            secure; (iii) you will not permit any third-party to use the
            username and password to access the Website; (iv) you will be liable
            for all such activities conducted pursuant to such use, whether
            authorised or not, whether utilised from your device or not.
          </p>

          <br />

          <p>
            5.4.4. Your username and password are Our property and We have the
            right, subject to these
          </p>

          <p>
            Terms and Conditions, to deny you access to the Website at any time.
          </p>

          <br />

          <p>
            5.4.5. Your account will be deactivated, or you will no longer be
            able to utilise certain functionalities of the Website nor will
            third parties be able to add or remove information from your
            account:
          </p>

          <br />

          <p>
            5.4.5.1. when you sell or vacate (as a tenant) your property within
            a Balwin development; and/or
          </p>

          <br />

          <p>5.4.5.2. if you breach any of these Terms and Conditions.</p>

          <br />

          <p>
            5.4.6. If you know or suspect that anyone other than you know your
            password, you must promptly notify us at{" "}
            <a href="mailto:support@thinkdigital.co.za">
              support@thinkdigital.co.za
            </a>
          </p>

          <br />

          <p>6. DATA PROTECTION POLICY</p>

          <br />

          <p>
            6.1. These Terms of Use also refer to our Data Protection Policy,
            which sets out the terms on which we process any Personal
            Information we collect from you, or that you provide to us, which
            also apply to your use of our Website.
          </p>

          <br />

          <p>
            6.2. Processing of all Personal Information will be subject to our
            Data Protection Policy. By submitting Personal Information or using
            the Website you agree to our Data Protection Policy.
          </p>

          <br />

          <p>
            6.3. You warrant that all Personal Information provided by you to us
            is accurate.
          </p>

          <br />

          <p>7. LIMITATION OF LIABILITY</p>

          <br />

          <p>
            7.1. The Website and all materials found on the Website are intended
            for information purposes and provided "as is" for your convenience
            without any warranty, representation, condition, undertaking, or
            terms of any kind, express or implied, statutory or otherwise,
            including without limitation, the warranties of merchantability,
            non-infringement of intellectual property, fitness for a particular
            purpose or suitability of the information, software or services, or
            that our website will be uninterrupted or error-free, unless
            otherwise entitled under law.
          </p>

          <br />

          <p>
            7.2. We do not warrant the accuracy or completeness of the
            information, text, graphics, links or other items contained in the
            Website. We may make changes / amendments to the Website, the
            policies, information described in the materials or content of these
            terms and conditions, at any time without notice. Any changes shall
            take effect upon posting to this Website. We make no commitment to
            update the materials and may discontinue any part of the Website or
            product or services or certain software or version of certain
            software for the utilisation of the Website.
          </p>

          <br />

          <p>
            7.3. Balwin, its directors, employees or its service providers will
            not be liable for any special, direct, indirect or consequential
            damages, expenses or losses whatsoever, including loss of profits or
            data, loss of revenue, anticipated savings, goodwill, reputation or
            any delays, whether in an action in contract or delict, arising out
            of the use or inability to use the Website or performance of the
            Website or non-performance of the Website, i.e. Website not
            availableas a result of 3rd party service providers, maintenance,
            enhancements, events outside Our control or force majeure events,
            even if we have been advised of the possibility of such damages.
          </p>

          <br />

          <p>
            7.4. WE WILL NOT BE LIABLE TO YOU FOR ANY DEFAULT OR DELAY IN THE
            PERFORMANCE OF OUR SERVICES TO YOU IF AND TO THE EXTENT THAT SUCH
            DEFAULT OR DELAY IS CAUSED BY, INCLUDING WITHOUT LIMITATION, ANY ACT
            OF GOD, PANDEMIC, EPIDEMIC, WAR, CIVIL DISTURBANCE, LABOUR UNREST,
            COURT ORDER, OR ANY OTHER CIRCUMSTANCE BEYOND ITS REASONABLE CONTROL
            INCLUDING FLUCTUATIONS IN COMMUNICATIONS OR UTILITY SERVICES ("FORCE
            MAJEURE") AND PROVIDED WE ARE OBVIOUSLY WITHOUT FAULT IN CAUSING
            SUCH DEFAULT OR DELAY, AND SUCH DEFAULT OR DELAY COULD NOT HAVE BEEN
            PREVENTED BY THE US THROUGH THE USE OF ALTERNATIVE SOURCES,
            WORKAROUND PLANS OR OTHER MEANS.
          </p>

          <br />

          <p>
            7.5. You hereby indemnify Us and undertake to keep Us indemnified
            against any losses, damages, costs, liabilities and expenses
            (including without limitation legal expenses and any amounts paid by
            Us to a third party in settlement of a claim or dispute on the
            advice of Our legal advisers) incurred or suffered by Us arising out
            of any breach by You of any provision of these terms and conditions,
            or arising out of any claim that you have breached any provision of
            these terms of use.
          </p>

          <br />

          <p>8. AGREEMENT(S) AND ECOMMUNICATIONS</p>

          <br />

          <p>8.1. You agree that:</p>

          <br />

          <p>
            8.1.1. you are at least 18 years of age and possess the legal
            capacity and ability to enter into this agreement and to use the
            Website in accordance with all Terms and Conditions herein;
          </p>

          <br />

          <p>
            8.1.2. if you are under 18 years of age, you will first get your
            parent/guardian's permission whenever you provide personal
            information to the Website. Acceptance of any such personal
            information by Us is not confirmation that We accept your right to
            submit the personal information;
          </p>

          <br />

          <p>
            8.1.3. all information that is incorporated by using hyperlinks
            and/or other methods of reference form part of this agreement;
          </p>

          <br />

          <p>
            8.1.4. this agreement is concluded when you access our Website.
            Specific service terms and conditions will apply subsequent to your
            acceptance of such terms and conditions by adding a tick to the
            “Accept Terms and Conditions” box and clicking on Login / Register.
            This agreement concluded at Our place of business (“Physical
            Address”).
          </p>

          <br />

          <p>8.2. Time and Place of communication, dispatch and receipt</p>

          <br />

          <p>
            8.2.1. a data message sent from Us to you has been sent from Our
            Physical Address;
          </p>

          <br />

          <p>
            8.2.2. a data messages sent from Us to you is deemed to be received
            by you when the complete message is outside the control of Our
            systems (i.e. has left Our system);
          </p>

          <br />

          <p>
            8.2.3. a data messages sent from you to Us is deemed to be received
            by Us only when We respond thereto.
          </p>

          <br />

          <p>8.3. Expression of intent</p>

          <br />

          <p>
            For purposes of electronic communications between you and Us no
            electronic signature is required; the mere sending of data messages
            or adding the tick to the applicable box andsubsequent click on
            Login demonstrates your intent to be a party to these Terms and
          </p>

          <p>Condition or any subsequent agreement.</p>

          <br />

          <br />

          <br />

          <p>8.4. Attribution of data messages to originator</p>

          <br />

          <p>
            You agree and warrant that the data message sent under your login
            credentials (i.e. username and password), to Us was sent by you or a
            person that has authority to act on your behalf in respect of the
            data message.
          </p>

          <br />

          <p>9. BREACH &amp; TERMINATION</p>

          <br />

          <p>
            9.1. We will determine, in our discretion, whether there has been a
            breach of these Terms and Conditions through your use of our
            Website. When a breach has occurred, we may take such action as we
            deem appropriate.
          </p>

          <br />

          <p>
            9.2. Failure to comply with these Terms and Conditions constitutes a
            material breach of the agreement upon which you are permitted to use
            Our Website, and may result in our taking all or any of the
            following actions:
          </p>

          <br />

          <p>
            9.2.1. immediate, temporary or permanent withdrawal of your right to
            use Our Website;
          </p>

          <br />

          <p>
            9.2.2. immediate, temporary or permanent removal of any posting or
            material uploaded by you to Our Website;
          </p>

          <br />

          <p>9.2.3. issuance of a warning to you;</p>

          <br />

          <p>
            9.2.4. institution of legal proceedings against you for damages
            and/or loss sustained by us
          </p>

          <p>
            (including legal costs on the attorney and own client scale); and/or
          </p>

          <br />

          <p>
            9.2.5. disclosure of such information to law enforcement authorities
            as We reasonably feel is necessary.
          </p>

          <br />

          <p>
            9.3. We exclude liability for actions taken in response to any
            breach of these Terms and Conditions. The actions described above
            are not limited, and We may take any other action We reasonably deem
            appropriate.
          </p>

          <br />

          <p>10. GENERAL AND MISCELLANEOUS</p>

          <br />

          <p>10.1. Sole record of agreement</p>

          <br />

          <p>
            10.1.1. These Terms and Conditions constitute the sole record of the
            agreement between you and Us relating to the use of the Website. Any
            other terms or conditions issued by Us and governing our
            relationship with you, and in particular relating to any service or
            purchase of product, shall supplement these Terms and Conditions. In
            the event of any inconsistency between these Terms and Conditions
            and any subsequently issued supplementary terms and conditions, the
            latter terms or conditions shall prevail over these Terms and
            Conditions.
          </p>

          <br />

          <p>
            10.1.2. Every time you access the Website, the terms and conditions
            available at that time will apply to the agreement between you and
            Us.
          </p>

          <br />

          <p>10.2. No amendments except in writing</p>

          <br />

          <p>
            10.2.1. We may revise these terms and conditions at any time. Any
            amended or new terms and conditions will be valid from the moment we
            place them on the Website. Using the Website or any part thereof
            after Login implies that you agree to the amended or newterms and
            conditions available to you. We will endeavour to notify you if
            there are new or amended terms and conditions. Some of the
            provisions contained in these terms and conditions may also be
            superseded by provisions or notices published elsewhere on the
            Website.
          </p>

          <br />

          <p>
            10.2.2. No data message, including but not limited to an e-mail, SMS
            and recorded voice message, sent by you to Us shall amend these
            Terms and Conditions or the rights and duties of the parties in any
            manner, unless such a data message is reduced to writing on paper
            and signed by the parties.
          </p>

          <br />

          <p>10.3. Waivers</p>

          <br />

          <p>
            No relaxation or indulgence, which any party may grant to any other,
            shall constitute a waiver of the rights of that party and shall not
            preclude that party from exercising any rights which may have arisen
            in the past or which might arise in future.
          </p>

          <br />

          <p>10.4. Survival of obligations</p>

          <br />

          <p>
            Any provision under these terms and conditions, which contemplates
            performance or observance subsequent to any termination, or
            expiration of this Agreement shall survive any termination or
            expiration of this Agreement and continue in full force and effect.
          </p>

          <br />

          <p>10.5. Severability</p>

          <br />

          <p>
            10.5.1. If any one or more of the clauses of these Terms and
            Conditions is declared or adjudged (formally or informally) by
            competent authority to be illegal, invalid or unenforceable under
            any law applicable in any jurisdiction in which these Terms and
            Conditions are to be performed, including this clause, then:
          </p>

          <br />

          <p>
            10.5.1.1. the offending clause shall be deemed for all purposes to
            be severable from all the other clauses of these Terms and
            Conditions, which clauses shall continue in force unaffected;
          </p>

          <br />

          <p>
            10.5.1.2. the Terms and Conditions thus continuing shall (subject
            and without prejudice to any appeal to higher authority as to the
            status of that clause) exclude the offending clause but, if such
            deletion substantially affects or alters the commercial basis of
            these Terms and Conditions, the Terms and Conditions, including such
            provision, shall be amended in such manner as the parties shall in
            good faith agree which will, while not being void or unenforceable,
            most nearly achieve the object of the void or unenforceable
            provisions.
          </p>

          <br />

          <p>
            10.6. Users with complaints or concerns may use the ‘Keep in touch
            with us’ section on the
          </p>

          <p>Website to lodge applicable complaints or concerns.</p>

          <br />

          <p>11. APPLICABLE AND GOVERNING LAW</p>

          <br />

          <p>
            These Terms and Conditions shall be governed by and interpreted in
            accordance with the laws of the Republic of South Africa, which
            shall have exclusive jurisdiction over any disputes.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  width: 95% !important;
  height: 100%;
  position: relative;
  float: none;
  margin: 0 auto;
  background: #fff;
  padding: 2%;
`;

export default Terms;
